import React from 'react';

import {TripBoardButton} from '@homeaway/react-trip-board-button';

export default function TripBoardComponent(props) {
    return React.cloneElement(props.children, {
        tripboardComponent: TripBoardButton,
    });
}
